export default "__VITE_ASSET__BuZE9oOl__"